import Operation from "../index.js";

export default {
    //获取考试时间
    newGetTestTimes(id, fn) {
        Operation.Http.post(`/testPaper/newGetTestTimes?testPaperId=${id}`, null, fn)
    },
    //查看试卷
    findTestPaper(id, fn) {
        Operation.Http.post(`/test/findTestPaper?testPaperId=${id}`, null, fn)
    },
    // 自主报名
    savePaper(testId,fun){
        Operation.Http.post(`/testPaper/savePaper?testId=${testId}`, null, fun)  
    },
    // 查当前角色有没有本考试的试卷
    findPaperByTestId(testId, fun) {
        Operation.Http.post(`/testPaper/findPaperByTestId?testId=${testId}`, null, fun)
    },
}


// WEBPACK FOOTER //
// ./src/request/api/testPaper.js